export function KioskStationControls({
  activeBindings,
  onRegisterChange,
  onSingleReadingModeChange,
  operatorName,
  selectedBinding,
  selectedRegisterId,
  singleReadingModeState,
}) {
  return (
    <div className="kiosk-card kiosk-card-light kiosk-card-compact">
      <div className="kiosk-info-row">
        <div className="kiosk-info-item">
          <label className="kiosk-select-field kiosk-info-field">
            <span className="kiosk-info-label">สถานี</span>
            <select
              value={selectedRegisterId}
              onChange={onRegisterChange}
              disabled={activeBindings.length === 0}
            >
              <option value="">
                {activeBindings.length === 0 ? 'ไม่มีสถานีที่ใช้งานได้' : 'เลือกสถานี'}
              </option>
              {activeBindings.map((binding) => (
                <option key={binding.registerId} value={binding.registerId}>
                  {binding.registerId}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="kiosk-info-divider" />
        <div className="kiosk-info-item">
          <label htmlFor="operator" className="kiosk-field kiosk-info-field">
            <span className="kiosk-info-label">ผู้ปฏิบัติงาน</span>
            <input
              id="operator"
              name="operatorName"
              value={operatorName}
              readOnly
              placeholder="ชื่อผู้ปฏิบัติงาน"
            />
          </label>
        </div>
        <div className="kiosk-info-divider" />
        <div className="kiosk-info-item kiosk-info-item-shrink">
          <label htmlFor="single-reading-mode" className="kiosk-toggle-label">
            <input
              id="single-reading-mode"
              type="checkbox"
              className="kiosk-toggle-input"
              checked={selectedBinding?.singleReadingMode ?? false}
              onChange={onSingleReadingModeChange}
              disabled={!selectedBinding || singleReadingModeState.type === 'pending'}
            />
            <span className="kiosk-info-label">ชั่งทีละครั้ง</span>
          </label>
          {singleReadingModeState.type === 'error' && (
            <p className="kiosk-error-inline">{singleReadingModeState.message}</p>
          )}
        </div>
      </div>
    </div>
  );
}
